export function formatNumber(value: number, decimals: number = 2, locale = 'pt-BR') {
  if (isNaN(value)) {
    //value = 0;
    throw new Error("O valor fornecido não é um número válido." + value);
  }

  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function formatNumbervalue(value: number, decimals: number = 4, locale = 'pt-BR') {
  if (isNaN(value)) {
    //value = 0;
    throw new Error("O valor fornecido não é um número válido." + value);
  }

  return Number(value).toLocaleString(locale, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export const formatMoeda = (value: number): string => {
  return new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);
};
